import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=ddab6bca&scoped=true&"
import script from "./Partnership.vue?vue&type=script&lang=js&"
export * from "./Partnership.vue?vue&type=script&lang=js&"
import style0 from "./Partnership.vue?vue&type=style&index=0&id=ddab6bca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddab6bca",
  null
  
)

export default component.exports